module.exports = __webpack_public_path__ + "static/letter-square-540w-04b67a0b87528f676a17367682c03408.jpg";